<ng-container *ngIf="profile$ | async as profile">
    <ng-container *ngIf="profileFields$ | async as profileFields">
        <fieldset *ngIf="profileFields.length > 0" [id]="profile.Id" class="sh-form-fieldset">
            <legend class="sh-form-fieldset__legend">{{ profile.Name }}</legend>

            <ng-container *ngFor="let profileField of profileFields$ | async">
                <sh-generic-field
                    *ngIf="profileField.FieldDefinition; else notFound"
                    [profileField]="profileField"
                    [formGroup]="formGroup"
                    [records]="records"
                    [recordInheritance]="recordInheritance"
                    [aiProfile]="aiProfile"
                    [isBatchEdit]="isBatchEdit"
                    [canEditStandard]="canEditStandard$ | async"
                    [canEditAdvanced]="canEditAdvanced$ | async"
                    [style.display]="isVisuallyHidden(profileField) ? 'none' : 'inherit'"
                    [autocompleteFct]="getAutocompleteFct(profileField)"
                    [subFieldAutocompleteFcts]="getSubFieldAutocompleteFcts(profileField)"
                    [nestedIndex]="0"
                >
                </sh-generic-field>

                <ng-template #notFound>
                    <dt class="sh-description-list__term">{{ profileField.DisplayLabel }}</dt>
                    <dd class="sh-description-list__details">
                        {{ "form.error.fielddefinition-not-found" | translate: { id: profileField.FieldDefinitionId } }}
                    </dd>
                </ng-template>
            </ng-container>
        </fieldset>
    </ng-container>
</ng-container>
